import { ApiDeposit, ApiLoan } from 'api/rtk-api'
import { useEffect } from 'react'
import { useUser } from 'utilities/hooks/useUser'

import CashInstrumentsLayout from '../layout/cash-inst-layout'
import { actions as rawActions, PageType } from '../state/edit-cash-instruments-slice'
import { useAppSelector } from '../store/hooks'
import { useActions } from '../store/use-actions'

type CashInstrumentAdminProps = {
  pageType: PageType
}

export const CashInstrumentAdminWithState = ({ pageType }: CashInstrumentAdminProps) => {
  const { data: user } = useUser()
  const state = useAppSelector(state => state.editCashInstruments)
  const actions = useActions(rawActions)
  useEffect(() => {
    actions.init(pageType)
  }, [actions, pageType])

  const canUserSave =
    user.organisation.organisationType === 'Administrator' ||
    user.roles.includes('Administrator') ||
    user.roles.includes('BankAdmin')

  const depositAndLoanInstruments = state.instruments as (ApiDeposit | ApiLoan)[]
  const depositOrLoanInstrument = state.selectedInstrument as ApiDeposit | ApiLoan

  return (
    <CashInstrumentsLayout
      actions={actions}
      availableCurrencies={state.availableCurrencies}
      availableRefRates={state.availableRefRates}
      canProceed={state.canProceed}
      canUserSave={canUserSave}
      errors={state.errors}
      instruments={depositAndLoanInstruments}
      isNew={state.isNew}
      saveSuccess={state.saveSuccess}
      selectedInstrument={depositOrLoanInstrument}
    />
  )
}
